import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rsvPipe',
  standalone: true
})
export class Rsv implements PipeTransform {

  transform(value: string): string {
    switch (value) {
      case 'RSV_TOD':
        return 'Basisschutz'
      case 'RSV_BU':
        return 'Standardschutz'
      case 'RSV_ALO':
        return 'Komplettschutz'
      default:
        return 'Kein Kreditschutz'
    }
  }

}
